import { useContext, useState } from 'react';
import { OrderContext } from '../context/OrderContext';

const useCreateRefund = () => {

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const {apiClient, setUuid, setOrderProduct, setProcess, setInvoiceProcess, setMissingProcess, setRefundProduct, 
        setRefundShipment} = useContext(OrderContext);
  



  const dataProducts = async (order_number, email, captchaToken) => {

    setLoading(true);
    setError(null);

    // const vendor_abbreviation =  "FLV"

    try {
      const payload = {
        order_number,
        email
      };
      if (captchaToken) {
        payload.captcha_token = captchaToken;
      }

      const response = await apiClient.post('api/v1/refund/create_refund/', payload);
      const data = response.data;

      setProducts(data.RelatedOrder);
      setOrderProduct(data.RelatedOrder)
      setRefundProduct(data?.claims)
      setUuid(data.UUID)
      setRefundShipment(data.shipments)

      let refund_process =  sessionStorage.setItem('refundProcess', JSON.stringify(data.refund_claim_processed));
      setProcess(data.refund_claim_processed)

      let invoice_process =  sessionStorage.setItem('invoiceProcess', JSON.stringify(data.invoice_claim_processed));
      setInvoiceProcess(data.invoice_claim_processed)

      let missing_process =  sessionStorage.setItem('missingProcess', JSON.stringify(data.missing_product_claim_processed));
      setMissingProcess(data.missing_product_claim_processed)

      return data
    } catch (error) {
      const msg = error.response?.data?.error || error.message || 'API error';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return { products, loading, error, dataProducts };
};

export default useCreateRefund;
